







































































































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import DropdownCheckbox from '@/components/DropdownCheckbox.vue';
import Box from '@/components/Box.vue';
import { AbstractDataClass } from '../helpers/AbstractDataClass';

@Component({
  components: {
    Box,
    DropdownCheckbox,
  },
})
export default class TrTableAdd<T> extends Vue {
  @Prop(Array) private arraySelect: Array<any>;
  @Prop(String) private nameDropdown: string;
  @Prop(String) private placeholder: String;
  @Prop(String) private placeholder2: String;
  @Prop(String) private to?: String;
  @Prop(Boolean) private isActive: Boolean;
  @Prop(Boolean) private finishEvent: Boolean;
  @Prop(Boolean) private canOtherPut: Boolean;

  @Prop(Object) private data: any;

  isPutActive: boolean = false;

  get isSmart() {
    let found: boolean = false;
    if (this.data.columns[0].isReadOnly) {
      found = true;
    } else {
      found = false;
    }
    return found;
  }

  @Emit('onDelete')
  onDelete() {}

  @Emit('deleteBox')
  deleteBox(arg: Object) {
    return arg;
  }

  @Emit('addBox')
  addBox(arg: Object) {
    return arg;
  }

  onPut(data: AbstractDataClass<T>) {
    this.isPutActive = false;
    this.$emit('onPut', data);
  }

  @Emit('onCreate')
  public onCreate(data: AbstractDataClass<T>) {
    return data;
  }

  @Emit('putEvent')
  public putEvent() {
    if (this.canOtherPut) {
      this.isPutActive = true;
    }
  }

  public onCancel() {
    if (!this.canOtherPut) {
      let Conf = confirm('Voulez-vous annuler votre action ?');
      if (Conf === true) {
        this.isPutActive = false;
        this.$emit('onCancel');
      }
    }
  }

  private dataClassIsNew(data: AbstractDataClass<T>): boolean {
    return data._id === undefined;
  }
}
